<div
  [class]="direction"
  [style.--size]="size"
  [style.--h-offset]="hOffset"
  [style.--v-offset]="vOffset"
  [style.--hide-at]="hideAt"
></div>
